import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyOtpMutationVariables = Types.Exact<{
  input: Types.VerifyOtpInput;
}>;

export type VerifyOtpMutation = {
  __typename?: 'Mutation';
  verifyOtp: {
    __typename?: 'VerifyOtpResponse';
    success: boolean;
    refreshToken?: string | null;
    accessToken?: string | null;
  };
};

export const VerifyOtpDocument = gql`
  mutation VerifyOtp($input: VerifyOtpInput!) {
    verifyOtp(input: $input) {
      success
      refreshToken
      accessToken
    }
  }
`;
export type VerifyOtpMutationFn = Apollo.MutationFunction<
  VerifyOtpMutation,
  VerifyOtpMutationVariables
>;
export function useVerifyOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyOtpMutation,
    VerifyOtpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(
    VerifyOtpDocument,
    options,
  );
}
export type VerifyOtpMutationHookResult = ReturnType<
  typeof useVerifyOtpMutation
>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<
  VerifyOtpMutation,
  VerifyOtpMutationVariables
>;
